import { defineStore } from 'pinia'
import { h, ref } from 'vue'
import type { MenuItem } from '@/components/menu/menu'
import {
  UserOutlined,
  DashboardOutlined,
  ToolOutlined,
  LockOutlined,
  RobotFilled,
  BarChartOutlined,
  SettingOutlined,
  BuildOutlined,
  DollarCircleOutlined,
  BookOutlined,
} from '@ant-design/icons-vue'
import { get_config } from '@/config'

const config = get_config()

const prefix = config.is_multitab ? '' : ''

export const useMenuStore = defineStore('menu', () => {
  const menuItems: MenuItem[] = [
    // {
    //   key: 'Dashboard',
    //   label: 'Dashboard',
    //   icon: () => h(DashboardOutlined),
    //   path: `${prefix}/dashboard`,
    // },
    {
      key: 'Assistants',
      label: 'Assistants',
      icon: () => h(RobotFilled),
      path: `${prefix}/assistant/list`,
    },
    {
      key: 'Tools',
      label: 'Tools',
      icon: () => h(ToolOutlined),
      path: `${prefix}/tool/list`,
    },
    {
      key: 'Auth-Methods',
      label: 'Auth Methods',
      icon: () => h(LockOutlined),
      path: `${prefix}/auth/list`,
    },
    {
      key: 'Data',
      label: 'Data',
      icon: () => h(BookOutlined),
      path: `${prefix}/data/list`,
    },
    {
      key: 'Users',
      label: 'Users',
      icon: () => h(UserOutlined),
      path: `${prefix}/user/list`,
    },
    // {
    //   key: 'Models',
    //   label: 'Models',
    //   icon: () => h(BuildOutlined),
    //   path: `${prefix}/model/list`,
    // },
    // {
    //   key: 'Usage',
    //   label: 'Usage',
    //   icon: () => h(BarChartOutlined),
    //   path: `${prefix}/usage`,
    // },
    // {
    //   key: 'Billing',
    //   label: 'Billing',
    //   icon: () => h(DollarCircleOutlined),
    //   path: `${prefix}/billing`,
    // },
    // {
    //   label: 'Help',
    //   icon: () => h(InfoCircleOutlined,
    //   path: `${prefix}/help`,
    // },
  ]
  const activeMenu = ref<MenuItem | undefined>()
  const is_collapsed = ref<boolean>(false)
  const is_visible = ref<boolean>(true)

  function setActiveMenu(menu: MenuItem | undefined) {
    activeMenu.value = menu
  }
  function toggleVisibility() {
    is_visible.value = !is_visible.value
  }
  function toggleCollapsped() {
    is_collapsed.value = !is_collapsed.value
  }
  function setVisibility(value: boolean) {
    is_visible.value = value
  }
  function setCollapsed(value: boolean) {
    is_collapsed.value = value
  }
  return {
    is_visible,
    is_collapsed,
    toggleVisibility,
    toggleCollapsped,
    setVisibility,
    setCollapsed,
    menuItems,
    activeMenu,
    setActiveMenu,
  }
})
